module.exports = __webpack_public_path__ + "img/Sonomed Escalon Logo for Dark Backgrounds.4ee28523.png";